/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { TemplatesControllerFindOneQueryResponse, TemplatesControllerFindOnePathParams, TemplatesControllerFindOneQueryParams, TemplatesControllerFindOne400, TemplatesControllerFindOne401, TemplatesControllerFindOne403, TemplatesControllerFindOne404 } from "../../models/checklistsController/TemplatesControllerFindOne";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { templatesControllerFindOne } from "../../clients/checklistsService/templatesControllerFindOne";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const templatesControllerFindOneQueryKey = (id: TemplatesControllerFindOnePathParams["id"], params: TemplatesControllerFindOneQueryParams = {}) => [{
  url: '/api/v1/checklist-templates/:id',
  params: {
    id: id
  }
}, ...(params ? [params] : [])] as const;
export type TemplatesControllerFindOneQueryKey = ReturnType<typeof templatesControllerFindOneQueryKey>;
export function templatesControllerFindOneQueryOptions(id: TemplatesControllerFindOnePathParams["id"], params?: TemplatesControllerFindOneQueryParams, config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = templatesControllerFindOneQueryKey(id, params);
  return queryOptions<TemplatesControllerFindOneQueryResponse, ResponseErrorConfig<TemplatesControllerFindOne400 | TemplatesControllerFindOne401 | TemplatesControllerFindOne403 | TemplatesControllerFindOne404>, TemplatesControllerFindOneQueryResponse, typeof queryKey>({
    enabled: !!id,
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return templatesControllerFindOne(id, params, config);
    }
  });
}

/**
 * @summary Get a specific checklist template by ID
 * {@link /api/v1/checklist-templates/:id}
 */
export function useTemplatesControllerFindOne<TData = TemplatesControllerFindOneQueryResponse, TQueryData = TemplatesControllerFindOneQueryResponse, TQueryKey extends QueryKey = TemplatesControllerFindOneQueryKey>(id: TemplatesControllerFindOnePathParams["id"], params?: TemplatesControllerFindOneQueryParams, options: {
  query?: Partial<QueryObserverOptions<TemplatesControllerFindOneQueryResponse, ResponseErrorConfig<TemplatesControllerFindOne400 | TemplatesControllerFindOne401 | TemplatesControllerFindOne403 | TemplatesControllerFindOne404>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? templatesControllerFindOneQueryKey(id, params);
  const query = useQuery({
    ...templatesControllerFindOneQueryOptions(id, params, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<TemplatesControllerFindOne400 | TemplatesControllerFindOne401 | TemplatesControllerFindOne403 | TemplatesControllerFindOne404>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}